
import {Component, Prop, Watch} from "vue-property-decorator";
import OverPriceSms from "@/components/OverPriceSms.vue";
import { mixins } from "vue-class-component";
import DocumentMixin from "@/mixins/DocumentMixin.vue";
import { formRules } from "@/utils/formRules";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";

@Component({
    components: {
        MylobyAutocomplete,
        OverPriceSms,
    },
})
export default class KeyGuestReminder extends mixins(DocumentMixin) {
    @Prop({default: () => null})
    public users: any[];

    @Prop({default: null})
    public keyId: number;

    @Prop({default: false})
    public loading: boolean;

    private modal: boolean = true;
    private loadingInvitationReminder: boolean = false;
    private notificationType: string = "email";
    private selectedGuest: any = null;
    private acceptOverPrice: boolean = false;
    private modalType: string = null;

    get allowMail(): boolean {
        return formRules.isEmail(this.selectedGuest?.email);
    }

    get allowPhone(): boolean {
        return !!this.selectedGuest?.phone;
    }

    get defaultNotificationType(): string {
        if (this.allowMail && !this.allowPhone) {
            return "email";
        }
        if (!this.allowMail && this.allowPhone) {
            return "sms";
        }
        return null;
    }

    @Watch("selectedGuest", {immediate: true})
    public handlerSelectedGuest(): void {
        this.notificationType = this.defaultNotificationType || "email";
    }

    @Watch("users", {deep: true, immediate: true})
    public handlerUsers(): void {
        if (this.users?.length === 1) {
            this.selectedGuest = this.users[0];
        }
    }

    private mounted(): void {
      //
    }

    private reset(): void {
      this.acceptOverPrice = false;
      this.selectedGuest = null;
      this.loadingInvitationReminder = false;
    }

    private send(): void {
        this.loadingInvitationReminder = true;
        this.modalType = null;
        this.$store.dispatch("keys/invitationReminder", {
            keyId: this.keyId,
            guestId: this.selectedGuest.id,
            notificationType: this.notificationType,
            acceptOverPrice: this.acceptOverPrice,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("actions.sent"),
            });
            this.$emit("success", this.selectedGuest);
            this.reset();
        }).catch((error) => {
            switch (error?.response?.data?.message) {
                case "smsLimitReached":
                    this.acceptOverPrice = true;
                    this.modalType = "smsLimitReached";
                    break;
                case "smsOverpriceLimitReached":
                    this.acceptOverPrice = true;
                    this.modalType = "smsOverpriceLimitReached";
                    break;
                case "freemium":
                    this.$store.commit("alerts/displayError", {
                        msg: this.$i18n.t("invitation.freemium"),
                    });
                    break;
                default:
                    this.$store.commit("alerts/displayHttpError", { error });
                    break;
            }
            this.loadingInvitationReminder = false;
        });
    }

    private close(): void {
        this.$emit("close");
        this.reset();
    }

    private itemStringified: (object) => string = (item: object): string => JSON.stringify(item);

    private itemParsed: (object) => object = (item: object): object => JSON.parse(JSON.stringify(item));
}
